var SwitchToLinkedAccountOutput = /** @class */ (function () {
    function SwitchToLinkedAccountOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountOutput.prototype.init = function (data) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    SwitchToLinkedAccountOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    SwitchToLinkedAccountOutput.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SwitchToLinkedAccountOutput();
        result.init(json);
        return result;
    };
    return SwitchToLinkedAccountOutput;
}());
export { SwitchToLinkedAccountOutput };
